"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var katex_1 = __importDefault(require("katex"));
require("katex/dist/katex.min.css");
var EditorLeaf = function (_a) {
    var attributes = _a.attributes, childrenProp = _a.children, highlightCardLink = _a.highlightCardLink, onClickCardLink = _a.onClickCardLink, leaf = _a.leaf, readonly = _a.readonly;
    var children = childrenProp;
    if (leaf.bold) {
        children = react_1.default.createElement("strong", null, children);
    }
    if (leaf.italic) {
        children = react_1.default.createElement("em", null, children);
    }
    if (leaf.underline) {
        children = react_1.default.createElement("u", null, children);
    }
    if (leaf.strikethrough) {
        children = react_1.default.createElement("s", null, children);
    }
    if (leaf.card &&
        (highlightCardLink === 'all' || leaf.cardId === highlightCardLink)) {
        children = (react_1.default.createElement("span", { role: onClickCardLink ? 'button' : undefined, tabIndex: onClickCardLink ? 0 : undefined, onClick: onClickCardLink ? function () { return onClickCardLink(leaf.cardId); } : undefined, style: {
                backgroundColor: '#E1F5FE',
                cursor: onClickCardLink ? 'pointer' : 'text',
            } }, children));
    }
    if (leaf.tex) {
        children = readonly ? (react_1.default.createElement("span", { 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: katex_1.default.renderToString(leaf.text, {
                    throwOnError: false,
                }),
            } })) : (react_1.default.createElement("span", __assign({}, attributes, { style: {
                padding: '3px 3px 2px',
                margin: '0 1px',
                verticalAlign: 'baseline',
                display: 'inline-block',
                borderRadius: '4px',
                backgroundColor: '#eee',
                fontSize: '0.9em',
            } }), children));
    }
    return react_1.default.createElement("span", __assign({}, attributes), children);
};
exports.default = EditorLeaf;
//# sourceMappingURL=EditorLeaf.js.map